<template>
  <div class="home">
	    <div class="box">	
			<router-link to="/organisations/add"><button class="button is-success">Add New Organisation</button></router-link><br /><br />
           <table class="table is-fullwidth  is-hoverable" v-if="loading === false && organisations.length > 0">
               <thead>
                   <tr>
                       <th>Name</th>
                      <th width="50">&nbsp;</th>
                       </tr>
                   </thead>
				   <tbody>
					   <tr v-for="row in organisations" :key="row.id">
						   <td><router-link :to="'/organisations/' + row.id">{{ row.name }}</router-link></td>
						   <td><router-link :to="'/organisations/' + row.id"><button class="button is-link is-small">View</button></router-link></td>
						   </tr>
					</tbody>
            </table>

            <div class="notification is-warning" v-if="loading === true">Loading ...</div>
			<div class="notification is-info" v-if="loading === false && organisations.length === 0">There are no Organisations setup yet</div>

            <router-link to="/organisations/add"><button class="button is-success">Add New Organisation</button></router-link>
        </div>
		
	</div>
</template>

<script>
import AwardsService from '@/services/AwardsService.js';

export default {
  name: 'Home',
	
	data: function () {
    	return {
		      organisations: [],
			  loading : true,
			  search: "",
				API_NAME: process.env.VUE_APP_API_NAME,
				accessToken: ''
		}
	},
	created() {
      this.getAccessToken()
        .then(() => { 
           this.getOrganisations();
		
        });
      
    },
	methods: {
		async getAccessToken() {
            this.accessToken = await this.$auth.getTokenSilently()
        },
		// Log the user in
		login() {
			this.$auth.loginWithRedirect();
		},
		async getOrganisations() {
			this.loading = true
			AwardsService.getOrganisations(this.accessToken, this.search)
			.then(
				(organisations => {
				this.$set(this, "organisations", organisations);
                this.loading = false
				}).bind(this)
			);
		},
		
		
	}
}
</script>
